export enum WalletConnectionType {
    PASSPORT = "PASSPORT",
    EOA_WALLET = "EOA_WALLET"
}